import { useState, useEffect, useContext } from "react";
import {
    Grid,
    TextField,
} from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';
import { ActionContext } from 'src/contexts/ActionContext';
import { BusinessManagerContext } from "src/contexts/BusinessManagerContext";

function ManagerComments(props) {
    const { t } = useTranslation();
    const { eepBMData } = useContext(BusinessManagerContext);
    const { actionToggle, isUserHimSelf } = useContext(ActionContext);
    const isVisu = !actionToggle;
    const [commentTrainingRequest, setCommentTrainingRequest] = useState('');
    useEffect(() => {
        if (props.data != undefined) {
            setCommentTrainingRequest(props.data)
        }
    }, [props.data]);
    const handleChange = (e) => {
        setCommentTrainingRequest(e.target.value);
    }
    const setDataContextValue = () => {
        eepBMData.commentTrainingRequest = commentTrainingRequest;
    }
    return (
        <Grid container direction="row" alignItems="stretch" sx={{ padding: 1 }} spacing={1}>
            <Grid item xs={12} >
                <TextField
                    label=""
                    variant="outlined"
                    fullWidth
                    name="commentTrainingRequest"
                    value={commentTrainingRequest}
                    onChange={handleChange}
                    onBlur={setDataContextValue}
                    multiline
                    inputProps={{
                        maxLength: 4094
                    }}
                    disabled={!isUserHimSelf ? isVisu : true}
                />
            </Grid>
        </Grid>
    );
}

export default ManagerComments;